import { render, staticRenderFns } from "./FormRooms.vue?vue&type=template&id=23956e5b&scoped=true&"
import script from "./FormRooms.vue?vue&type=script&lang=js&"
export * from "./FormRooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23956e5b",
  null
  
)

export default component.exports